import React from "react";
import Intro from "../../component/Intro";
import ServicesSection from "../../component/service-comp/Services";
import Footer from "../../component/footer";

function About({ mode, setmymode }) {
  const textinline4 = {
    headh1: "About",
    spano: "The Team",
    subh1: "konw more about our team and services we offer",
    paragraph1:
      "Our team is one of most powerful developers in the middle east , this team is a start up of victrious peole.",
  };
  return (
    <div>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline4} />
      <ServicesSection />
      <Footer />
    </div>
  );
}

export default About;
